<app-header></app-header>
<app-leftsidebar></app-leftsidebar>
<main class="checkout-shell">
<div class="checkout-page">
  <div class="co-head">
    <h1>Checkout</h1>
    <ol class="co-steps" aria-label="Checkout steps">
      <li class="is-done">
        <a routerLink="/marketplace/cart">
          <span class="co-step-dot"><svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg></span>
          Cart
        </a>
      </li>
      <li class="is-current" aria-current="step"><span class="co-step-dot">2</span>Payment</li>
      <li><span class="co-step-dot">3</span>Download</li>
    </ol>
  </div>

  @if (loading) {
    <div class="co-body" aria-busy="true" aria-label="Preparing your order">
      <div class="co-panel">
        <span class="co-skel co-skel--title"></span>
        <span class="co-skel co-skel--field"></span>
        <span class="co-skel co-skel--field"></span>
        <div class="co-skel-row">
          <span class="co-skel co-skel--field"></span>
          <span class="co-skel co-skel--field"></span>
        </div>
        <span class="co-skel co-skel--btn"></span>
        <p class="co-preparing"><span class="co-spinner" aria-hidden="true"></span> Preparing your order…</p>
      </div>
      <aside class="co-summary">
        <span class="co-skel co-skel--title"></span>
        <span class="co-skel co-skel--item"></span>
        <span class="co-skel co-skel--item"></span>
      </aside>
    </div>
  } @else if (errorMessage) {
    <div class="co-empty">
      <span class="co-empty-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><line x1="12" y1="7.5" x2="12" y2="12.5" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
      </span>
      <h3>{{ needsSignIn ? 'Please sign in again' : "Can't check out yet" }}</h3>
      <p>{{ errorMessage }}</p>
      @if (needsSignIn) {
        <a routerLink="/login" class="wt-btn-primary">Sign in</a>
      } @else {
        <a routerLink="/marketplace/cart" class="wt-btn-primary">Back to cart</a>
      }
    </div>
  } @else {
    <div class="co-body">
      <!-- ===== Payment ===== -->
      <div class="co-panel">
        <div class="co-panel-head">
          <div>
            <h2>Payment details</h2>
            <p class="co-panel-sub">Choose how you'd like to pay.</p>
          </div>
          <span class="co-secure">
            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
            Secure
          </span>
        </div>

        @if (elementsOptions.clientSecret) {
          <div class="stripe-wrapper">
            @if (!paymentReady) {
              <div class="co-form-skel" aria-hidden="true">
                <div class="co-skel-row co-skel-row--tabs">
                  <span class="co-skel co-skel--tab"></span><span class="co-skel co-skel--tab"></span><span class="co-skel co-skel--tab"></span>
                </div>
                <span class="co-skel co-skel--field"></span>
                <div class="co-skel-row">
                  <span class="co-skel co-skel--field"></span>
                  <span class="co-skel co-skel--field"></span>
                </div>
              </div>
            }
            <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
              <ngx-stripe-payment [options]="paymentElementOptions" (ready)="onPaymentReady()"></ngx-stripe-payment>
            </ngx-stripe-elements>
          </div>

          @if (payError) {
            <div class="co-pay-error" role="alert">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><line x1="12" y1="7.5" x2="12" y2="12.5" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
              <span><strong>The payment didn't go through.</strong> {{ payError }} Nothing was charged; you can try again or pick another way to pay.</span>
            </div>
          }
          <button type="button" class="wt-btn-primary co-pay" [disabled]="paying || !paymentReady" (click)="pay()">
            @if (paying) {
              <span class="co-spinner co-spinner--dark" aria-hidden="true"></span> Processing payment…
            } @else {
              <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
              Pay {{ money(intent?.total) }}
            }
          </button>

          <ul class="co-perks">
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
              <span><strong>Paid through Stripe</strong>We never see or keep your card.</span>
            </li>
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
              <span><strong>Download right away</strong>Your files are ready the moment you pay.</span>
            </li>
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>
              <span><strong>Yours to keep</strong>Saved in My purchases and your Content Vault.</span>
            </li>
          </ul>
        } @else {
          <p class="co-fineprint">The payment form isn't available right now. Please go back to your cart and try again.</p>
        }
      </div>

      <!-- ===== Order summary ===== -->
      <aside class="co-summary">
        <div class="co-panel-head">
          <h2>Your order</h2>
          @if (intent?.order_number) { <span class="co-order">{{ intent?.order_number }}</span> }
        </div>
        @if (lines.length) {
          <ul class="co-items">
            @for (line of lines; track line.id) {
              <li>
                <span class="co-item-thumb">
                  @if (line.listing_detail.cover_image) { <img [src]="line.listing_detail.cover_image" alt="" loading="lazy" /> }
                </span>
                <span class="co-item-text">
                  <span class="co-item-title">{{ line.listing_detail.title }}</span>
                  <span class="co-item-shop">by {{ line.listing_detail.vendor.shop_name }}@if (line.quantity > 1) { · × {{ line.quantity }} }</span>
                  @if (line.listing_detail.fulfillment_type === 'digital') {
                    <span class="co-item-kind">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
                      Digital download
                    </span>
                  }
                </span>
                <span class="co-item-price">{{ money(line.line_total) }}</span>
              </li>
            }
          </ul>
        }
        <div class="co-sum-rows">
          <div class="co-sum-row">
            <span>Subtotal</span>
            <span>{{ money(intent?.subtotal) }}</span>
          </div>
          @if (intent && +(intent.discount_total || 0) > 0) {
            <div class="co-sum-row co-sum-discount">
              <span>Discount{{ intent.coupon ? ' (' + intent.coupon + ')' : '' }}</span>
              <span>-{{ money(intent.discount_total) }}</span>
            </div>
          }
        </div>
        <div class="co-total">
          <span>Total</span>
          <span>{{ money(intent?.total) }}</span>
        </div>
        <a routerLink="/marketplace/cart" class="co-edit">
          <svg viewBox="0 0 24 24" aria-hidden="true"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
          Edit cart
        </a>
      </aside>
    </div>
  }
</div>
</main>
<app-footer></app-footer>
